import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
import { TrustRow } from './TrustRow';
import { BOX_IMG, CHECKOUT_URL } from './constants';
export function PricingCard() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 30,
    seconds: 5
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) seconds--;else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 1;
          minutes = 30;
          seconds = 5;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const units = [{
    value: timeLeft.hours,
    label: 'ORE'
  }, {
    value: timeLeft.minutes,
    label: 'MIN'
  }, {
    value: timeLeft.seconds,
    label: 'SEC'
  }];
  return <section id="pricing" className="py-6 px-4 sm:px-6 bg-white border-y-4 border-gold/40 scroll-mt-2" data-id="element-109" data-mp="32k2id6jj5x42">
      <div className="text-center mb-3" data-id="element-110" data-mp="37i42lusp02h4">
        <p className="text-[11px] sm:text-sm font-heading font-bold text-gold-dark uppercase tracking-widest mb-1" data-id="element-111" data-mp="2suixxwg65v73">
          Offerta Speciale — Sistema Completo 6-in-1
        </p>
        <h2 className="text-base sm:text-2xl font-heading font-extrabold text-navy leading-tight mb-2" data-id="element-112" data-mp="2xrj4e8gxkzyq">
          Accedi subito al sistema completo e rivoluziona il modo in cui prepari i
          programmi dei tuoi runner.
        </h2>
        <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block cursor-pointer" data-id="element-113" data-mp="29w6nm7diuf9x">
          <img src={BOX_IMG} alt="RUNNING COACH PRO — Sistema Completo 6-in-1 per Running Coach" className="w-full max-w-[200px] mx-auto object-contain drop-shadow-lg hover:scale-[1.02] transition-transform duration-300" data-id="element-114" data-mp="2euzzjvd5ty7z" />
        </a>
      </div>

      <div className="max-w-md mx-auto bg-cream border-2 border-gold rounded-xl p-3.5 sm:p-6 text-center mb-3 shadow-lg" data-id="element-115" data-mp="bniwicf4xaiw">
        <p className="font-heading font-bold text-navy text-[11px] sm:text-sm uppercase tracking-wide mb-2 leading-snug" data-id="element-116" data-mp="6phe7tpj9f8h">
          🏃 RUNNING COACH PRO™ — Sistema Completo 6-in-1 per Running Coach
        </p>

        <p className="text-[13px] font-semibold text-anthracite mb-0.5" data-id="element-117" data-mp="ucpgs3vkua6t">
          Prezzo di Listino: <span className="line-through" data-id="element-118" data-mp="pdmcilnf87zw">97€</span>
        </p>
        <p className="text-[11px] sm:text-sm font-heading font-bold text-gold-dark mb-0.5 uppercase tracking-wide" data-id="element-119" data-mp="pe5v84kwb0ez">
          🔥 72% DI SCONTO — Offerta di Lancio a Tempo Limitato
        </p>
        <p className="text-[34px] sm:text-5xl font-heading font-extrabold text-navy leading-none mb-1" data-id="element-120" data-mp="gkj0mhsfc37d">
          Oggi Solo: 27€
        </p>
        <p className="text-[10px] font-semibold text-anthracite uppercase tracking-widest mb-3" data-id="element-121" data-mp="18ci6pwza4mdq">
          Pagamento sicuro nella tua valuta.
        </p>

        <div className="bg-white border border-gold/40 rounded-lg p-2.5 mb-3" data-id="element-122" data-mp="2r0jmu8tc9oyz">
          <p className="text-[10.5px] sm:text-xs font-heading font-bold text-navy mb-1.5 uppercase tracking-wide" data-id="element-123" data-mp="2vxjlvzrrtrgl">
            ⏳ Questa offerta terminerà allo scadere del conto alla rovescia.
          </p>
          <div className="flex justify-center gap-1.5" data-id="element-124" data-mp="3502iw38vl9ux">
            {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-125" data-mp="39x1dso0d5ku6" data-mpi={i}>
                {i > 0 && <span className="text-lg font-bold text-navy leading-7" data-id="element-126" data-mp="3ewnpgt0jmt0v">:</span>}
                <div className="text-center" data-id="element-127" data-mp="3jndvm8gsmzwm">
                  <div className="bg-navy text-white text-lg font-heading font-bold px-2.5 py-1.5 rounded min-w-[46px] leading-none" data-id="element-128" data-mp="3jopap4fovu31">
                    {String(unit.value).padStart(2, '0')}
                  </div>
                  <p className="text-[9px] font-bold text-navy/70 mt-0.5 tracking-widest" data-id="element-129" data-mp="3smhhfk7chtet">
                    {unit.label}
                  </p>
                </div>
              </React.Fragment>)}
          </div>
        </div>

        <CTAButton checkout data-id="element-130" data-mp="3f2eksdy12vee">🚀 SÌ! VOGLIO RUNNING COACH PRO™ ORA</CTAButton>
      </div>

      <TrustRow data-id="element-131" data-mp="3tqhunyf6yr8h" />
    </section>;
}